module.exports = __webpack_public_path__ + "img/hslu_logo.fb8cb050.png";